export enum ThresholdValue {
    NOT_APPLICABLE = 'N/A',
    LIMITED = 'LIMITED'
}